module.exports = __webpack_public_path__ + "static/img/office-sydney.afb76f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/office-sydney.png
// module id = /pL5
// module chunks = 1